import React, { Component } from "react";
import SidebarMobileMenu from "./SidebarMoblieMenu";
export class SidebarMobileMain extends Component {
  render() {
    return (
      <div className="navigation">
        <SidebarMobileMenu />
      </div>
    );
  }
}

export default SidebarMobileMain;
